import { render, staticRenderFns } from "./AddRekeysTextarea.vue?vue&type=template&id=559f6222&scoped=true&"
import script from "./AddRekeysTextarea.vue?vue&type=script&lang=js&"
export * from "./AddRekeysTextarea.vue?vue&type=script&lang=js&"
import style0 from "./AddRekeysTextarea.vue?vue&type=style&index=0&id=559f6222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../vue/vue2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "559f6222",
  null
  
)

export default component.exports